import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  list: [],
  details: null,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const childCareServiceSlice = createSlice({
  name: "childCareService",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    childCareServiceFetched: (state, action) => {
      state.actionsLoading = false;
      state.details = action.payload.data;
      state.error = null;
    },
  },
});